import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Anchor, Instagram, Mail, MessageCircle } from 'lucide-react';
import { Button } from './ui';
import { FloatingActions } from './FloatingActions';
const WHATSAPP_URL = 'https://wa.me/5491122836110?text=' + encodeURIComponent('Hola! Me interesa el viaje a Fernando de Noronha 2026.');
const INSTAGRAM_URL = 'https://www.instagram.com/buceoynavegacion/';
const socials = [{
  name: 'WhatsApp',
  href: WHATSAPP_URL,
  external: true,
  Icon: MessageCircle
}, {
  name: 'Instagram',
  href: INSTAGRAM_URL,
  external: true,
  Icon: Instagram
}, {
  name: 'Email',
  href: 'mailto:info@buceoynavegacion.com',
  external: false,
  Icon: Mail
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`absolute top-0 left-0 right-0 z-50 bg-transparent py-7 transition-opacity duration-300 ${isScrolled ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} data-id="element-327">
      <div className="container mx-auto px-6 flex items-start justify-between gap-4" data-id="element-328">
        {/* Brand block */}
        <a href="#" className="flex flex-col group" data-id="element-329">
          <div data-id="element-330">
            <h2 className="font-heading font-bold text-xl sm:text-2xl md:text-3xl leading-[1.05] tracking-[0.12em] text-noronha-text-heading uppercase" data-id="element-331">
              Buceo y
              <br data-id="element-332" />
              Navegación
            </h2>
            <div className="mt-3 flex flex-col gap-0.5 font-mono text-[10px] sm:text-xs tracking-[0.18em] text-noronha-emerald uppercase" data-id="element-333">
              <span data-id="element-334">Escuela de Buceo</span>
              <span data-id="element-335">Viajes Grupales</span>
              <span data-id="element-336">Agencia de Turismo HC 26.614</span>
            </div>
          </div>
        </a>

        {/* Socials + CTA */}
        <div className="flex flex-col items-end gap-4 shrink-0" data-id="element-337">
          <div className="flex items-center gap-3" data-id="element-338">
            {socials.map(({
            name,
            href,
            external,
            Icon
          }) => <a key={name} href={href} aria-label={name} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-full border border-noronha-petroleum/60 text-noronha-text-heading hover:border-noronha-emerald hover:text-noronha-emerald hover:bg-noronha-emerald/10 transition-all duration-300" data-id="element-339">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.75} data-id="element-340" />
              </a>)}
          </div>
          <Button variant="primary" className="hidden sm:inline-flex py-2.5 px-5 text-xs" data-id="element-341">
            Reservar mi lugar
          </Button>
        </div>
      </div>
    </header>;
}
export function Footer() {
  return <footer className="bg-noronha-graphite border-t border-noronha-petroleum/30 pt-20 pb-10" data-id="element-342">
      <div className="container mx-auto px-6" data-id="element-343">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-344">
          <div className="md:col-span-2" data-id="element-345">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-346">
              <Anchor className="w-6 h-6 text-noronha-emerald" data-id="element-347" />
              <span className="font-heading font-semibold text-xl text-noronha-text-heading" data-id="element-348">
                Buceo y Navegación
              </span>
            </a>
            <p className="text-noronha-text-body max-w-sm" data-id="element-349">
              Expediciones de buceo premium en los destinos más exclusivos del
              planeta. Naturaleza, aventura y excelencia.
            </p>
          </div>
          <div data-id="element-350">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-351">
              Destinos
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-352">
              <li data-id="element-353">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-354">
                  Bonaire
                </a>
              </li>
              <li data-id="element-355">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-356">
                  Fernando de Noronha
                </a>
              </li>
              <li data-id="element-357">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-358">
                  Galápagos
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-359">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-360">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-361">
              <li data-id="element-362">
                <a href="mailto:info@buceoynavegacion.com" className="hover:text-noronha-emerald transition-colors" data-id="element-363">
                  info@buceoynavegacion.com
                </a>
              </li>
              <li data-id="element-364">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-365">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-366">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-367">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-noronha-petroleum/30 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-noronha-text-body/60" data-id="element-368">
          <p data-id="element-369">
            © {new Date().getFullYear()} Buceo y Navegación. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-370">
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-371">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-372">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-noronha-volcanic text-noronha-text-body font-sans selection:bg-noronha-emerald/30 selection:text-noronha-text-heading" data-id="element-373">
      <Navbar data-id="element-374" />
      <main data-id="element-375">{children}</main>
      <FloatingActions data-id="element-376" />
    </div>;
}